import useDefinedContext from "hooks/useDefinedContext";
import SelectedWorkoutLabelsContext from "../SelectedWorkoutLabelsContext";

function useSelectedWorkoutLabels() {
  return useDefinedContext(SelectedWorkoutLabelsContext);
}

export default useSelectedWorkoutLabels;
